import { combine, withCallbacks, withContext } from 'react-hooks-combine'
import { spec, validators } from 'utils/validation'
import { withFormModel } from 'shared/hooks'
import { ServicesContext } from 'services/context'

import Step2FormComponent from './component'

const { string, any } = validators

export default combine(
	withContext(
		'jurisdictionsService',
		ServicesContext,
		({ jurisdictionsService }) => jurisdictionsService
	),
	withFormModel(
		{
			addressLine1: {
				alias: 'Address Line 1',
				spec: spec.flow(
					string.isString
				),
			},
			addressLine2: {
				alias: 'Address Line 2',
				spec: spec.flow(
					string.isString
				),
			},
			country: {
				alias: 'Country',
				spec: spec.flow(),
			},
			postalCode: {
				alias: 'Postal Code',
				spec: spec.flow(
					string.isString
				),
			},
			state: {
				alias: 'State',
				spec: spec.flow(
					string.isString
				),
			},
			city: {
				alias: 'City',
				spec: spec.flow(
					string.isString
				),
			},
		},
		{ id: 'step2-form' }
	),

	withCallbacks(
		{
			getOptionLabel:
				() =>
					({ name }) =>
						name,
			getOptionValue:
				() =>
					({ id }) =>
						id,

			loadJurisdictions:
				({ jurisdictionsService }) =>
					(search = '') =>
						jurisdictionsService.getJurisdictionsPublic({ search }),

			onSubmitForm: {
				deps: ['onComplete'],
				func:
					(_state, { onComplete }) =>
						(entity) => {
							// Handle form submission logic here

							// Map to the correct field names that the API expects
							const mappedEntity = {
								address: {
									address1: entity.addressLine1,
									address2: entity.addressLine2,
									zip: entity.postalCode,
									state: entity.state,
									city: entity.city,
									country: entity.country?.name || '',
								}
							}

							// Call onComplete to proceed
							if (onComplete) {
								onComplete(mappedEntity)
							}
						},
			},

			onSkip: {
				deps: ['onSkip'],
				func:
					(_state, { onSkip }) =>
						() => {
							if (onSkip) {
								onSkip()
							}
						},
			},

			onBack: {
				deps: ['onBack'],
				func:
					(_state, { onBack }) =>
						() => {
							if (onBack) {
								onBack()
							}
						},
			},
		},
		[]
	)
)(Step2FormComponent) 